import nft1 from "assets/img/nfts/NftBanner1.png";
import { useNavigate } from 'react-router-dom';
const Banner = () => {
  const navigate = useNavigate();
  const handleClick= () => {
   navigate('/admin/profile');
  }
  return (
    <div
      className="flex w-full flex-col rounded-md bg-cover px-[8px] py-[30px] md:px-[24px] md:py-[56px] mb-3"
      style={{ backgroundImage: `url(${nft1})` }}
    >
      <div className="w-full">
        <h5 className="mb-[12px] max-w-full text-xl font-bold text-white md:w-[64%] md:text-3xl md:leading-[42px] lg:w-[46%] xl:w-[85%] 2xl:w-[75%] 3xl:w-[52%]">
          Transform Your Student's Academic Journey Today
        </h5>
        <p className="mb-[40px] max-w-full text-base font-medium text-[#E3DAFF] md:w-[64%] lg:w-[40%] xl:w-[72%] 2xl:w-[60%] 3xl:w-[45%]">
        Join hundreds of families who have discovered the Apex advantage
        </p>

        <div className="mt-[36px] flex items-center justify-between gap-4 sm:justify-start 2xl:gap-10">
          <button onClick={handleClick} className="text-black linear rounded-md bg-white px-4 py-2 text-center text-base font-medium transition duration-200 hover:!bg-white/80 active:!bg-white/70">
           Get Started With Apex
          </button>
        </div>
      </div>
    </div>
  );
};

export default Banner;
